module.exports = __webpack_public_path__ + "media/images/flags/64/Ireland-c706bfc8811392d5e3fd6b74e20cfa97.png";